import { render, staticRenderFns } from "./CustomerGroupMixin.vue?vue&type=template&id=9c0becdc&"
import script from "./CustomerGroupMixin.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports